import {GitHubAvatar} from '@github-ui/github-avatar'
import {userHovercardPath} from '@github-ui/paths'
import {Box, Link} from '@primer/react'
import {graphql, useFragment} from 'react-relay'

import type {IssueBodyHeaderAuthor$key} from './__generated__/IssueBodyHeaderAuthor.graphql'

export const IssueBodyHeaderAuthorFragment = graphql`
  fragment IssueBodyHeaderAuthor on Actor {
    ... on User {
      login
      avatarUrl
      __typename
    }
    ... on Bot {
      login
      avatarUrl
      __typename
    }
    ... on Mannequin {
      login
      avatarUrl
      __typename
    }
  }
`

export function IssueBodyHeaderAuthor({author, showLogin}: {author: IssueBodyHeaderAuthor$key; showLogin?: boolean}) {
  const actorData = useFragment(IssueBodyHeaderAuthorFragment, author)

  if (actorData.__typename === '%other') return null

  const {login, avatarUrl} = actorData

  return (
    <Box sx={{display: showLogin ? 'inline' : 'block'}}>
      <Link
        href={`/${login}`}
        data-hovercard-url={userHovercardPath({owner: login})}
        sx={{
          color: 'fg.default',
          fontWeight: 500,
        }}
      >
        {/* we should keep the size in sync with VALUES.timelineAvatarSize but for some reasons this breaks the storybook for the issue-viewer :/ */}
        {showLogin ? login : <GitHubAvatar src={avatarUrl} size={24} alt={`@${login}`} />}
      </Link>
    </Box>
  )
}

try{ IssueBodyHeaderAuthor.displayName ||= 'IssueBodyHeaderAuthor' } catch {}